var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { ModalProvider } from './popup/modal';
import { Muteable, MuteableModalProvider } from './popup/muteable-modal';
var AnomalyWorkflowProvider = /** @class */ (function () {
    function AnomalyWorkflowProvider(modalProvider, muteableModalProvider) {
        this.modalProvider = modalProvider;
        this.muteableModalProvider = muteableModalProvider;
    }
    AnomalyWorkflowProvider.prototype.open = function (datasetIdentifier, postUploadHandler, force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var workflowModal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!force) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.muteableModalProvider.isMuted(Muteable.AnomalyWorkflowModal)];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        workflowModal = this.modalProvider.createModal(Muteable.AnomalyWorkflowModal, {
                            hideDoNotShowAgain: force
                        }, { cssClass: 'anomaly-workflow-modal', enableBackdropDismiss: false });
                        workflowModal.onDidDismiss(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (data && data.goToUpload) {
                                            this.upload(datasetIdentifier, postUploadHandler);
                                        }
                                        if (!(data && data.doNotShowAgain)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.muteableModalProvider.setMutedState(Muteable.AnomalyWorkflowModal, true)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        workflowModal.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    AnomalyWorkflowProvider.prototype.upload = function (datasetIdentifier, postUploadHandler) {
        var _this = this;
        var uploadModal = this.modalProvider.createModal('UploadModal', { datasetIdentifier: datasetIdentifier }, { cssClass: 'modal-upload' });
        uploadModal.onDidDismiss(function () { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!postUploadHandler) return [3 /*break*/, 2];
                        return [4 /*yield*/, postUploadHandler()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); });
        uploadModal.present();
    };
    /**
     * When user clicks Back button, we don't have an explicit way to close the open modal(s).
     * For example, user can be shown AnomalyWorkflowModal if there is no data (or first time creating a dataset).
     * When user clicks back, modal is still being displayed, even though user is on a different page.
     * Thus, this method provides a way to close (dismiss) modals when datasets page is being 'destroyed' (ngOnDestroy).
     */
    AnomalyWorkflowProvider.prototype.closeAll = function () {
        this.modalProvider.closeAll();
    };
    AnomalyWorkflowProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [ModalProvider, MuteableModalProvider])
    ], AnomalyWorkflowProvider);
    return AnomalyWorkflowProvider;
}());
export { AnomalyWorkflowProvider };
//# sourceMappingURL=anomaly_workflow.js.map


// WEBPACK FOOTER //
// ./src/providers/anomaly_workflow.ts.pre-build-optimizer.js